import { useMemo } from 'react';
import { store }   from 'index';
import { pages }   from 'utils/constants'

const useDropDownItems = (
  bigNavBar:    boolean,
  openDropDown: string,
  links:        string[],
  selfTeaching: string[],
) => {

  const state        = store.getState();
  const userLogedOut = state.data.userInfo.userLogedIn === 'false';

  const dropDownItems = useMemo(() => {

    if (openDropDown === 'links') {
      return links;
    }
    if (openDropDown === 'selfTeaching') {
      return selfTeaching;
    }
     
     
     const arr = ['joinLesson', 'aboutUs', 'contact us', 'privacy', (userLogedOut ? 'signIn' : 'signOut')];

     if (!bigNavBar) {
       return pages.concat(arr)
     }
     

     return arr;

  },[bigNavBar, userLogedOut, openDropDown, links, selfTeaching])


  return dropDownItems;
}


export default useDropDownItems;



